export const VIEW_TRACKER_OVERRIDE_COOKIES = {
  TOTAL: 'wws__override_view_tracker_count_total',
  WEEKLY: 'wws__override_view_tracker_count_weekly',
};
